import script from "./RelatedContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelatedContent.vue?vue&type=script&setup=true&lang=ts"

import "./RelatedContent.vue?vue&type=style&index=0&id=a3ba01a0&lang=scss"

const __exports__ = script;

export default __exports__